import type React from "react";
import { ReactComponent as Svg } from "./assets/username.svg";
import * as styles from "./Icon.module.scss";

type UsernameProps = React.SVGProps<SVGSVGElement>;

export const Username = ({ className, ...props }: UsernameProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
